import { notificationTypes } from '@/helpers/enums';
import store from '@/store';

export const notificationOptions = {
	icon: '/logo.png',
	dir: 'rtl',
	lang: 'ar-SA',
};

export const notificationPageRedirect = [
	{ type: notificationTypes.message, redirect: '/chat', routeName: 'chat' },
	{ type: notificationTypes.attendance, redirect: '/attendance', routeName: 'attendance' },
	{ type: notificationTypes.newMark, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.newMarks, redirect: '/grades', routeName: 'grades' },
	{ type: notificationTypes.schedule, redirect: '/schedule', routeName: 'schedule' },
	{ type: notificationTypes.newTest, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.testsSchedule, redirect: '/exams', routeName: 'exams' },
	{ type: notificationTypes.transport, redirect: '/', routeName: 'home' },
	{ type: notificationTypes.notes, redirect: '/behavior', routeName: 'behavior' },
];

export const firebase = {
	configs: {
		apiKey: 'AIzaSyBxuqT_oYTBQerxhM8SPPJx2n3qK5ijUs4',
		authDomain: 'edunix-apps.firebaseapp.com',
		projectId: 'edunix-apps',
		storageBucket: 'edunix-apps.firebasestorage.app',
		messagingSenderId: '707305277787',
		appId: '1:707305277787:web:179430b939dc93a44cb27e'
	},
	publicKey: 'BAhXjT_DTW0_sIy3l_FdjtuS6gAFO8Y1YKmtUBd50_GeKza0VF_bsq-hYwNOpRgEGIyk7L_sslEsRhr1qG6eU_g',
};

export const onGetNotification = () => {
	store.dispatch('notification/fetchAll');
};
